(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mawj-crystal-preview"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('[data-mawj-crystal]').forEach(function (root) {
      if (root.dataset.mcpInit) return;
      root.dataset.mcpInit = '1';
      var q = function (s) { return root.querySelector(s); };
      var tiles = root.querySelectorAll('.mcp__tile');
      var fileEl = q('[data-file]'), emptyEl = q('[data-empty]'), uploadEl = q('[data-upload]');
      var stage = q('[data-stage]'), wrap = q('[data-photo-wrap]'), photo = q('[data-photo]');
      var overlay = q('[data-overlay-img]'), controls = q('[data-controls]'), scale = q('[data-scale]');
      var resetBtn = q('[data-reset]'), hint = q('[data-hint]'), order = q('[data-order]');
      var dlBtn = q('[data-download]'), shBtn = q('[data-share]');
      var st = { scale: 100, x: 0, y: 0, shape: 'heart' };
      var raf = false;

      function apply() {
        photo.style.transform = 'translate3d(-50%,-50%,0) translate3d(' + st.x + 'px,' + st.y + 'px,0) scale(' + (st.scale / 100) + ')';
      }
      function sched() { if (raf) return; raf = true; requestAnimationFrame(function () { raf = false; apply(); }); }

      tiles.forEach(function (t) {
        t.addEventListener('click', function () {
          tiles.forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
          st.shape = t.dataset.shape;
          overlay.src = t.dataset.overlay;
          if (order && t.dataset.href) order.setAttribute('href', t.dataset.href);
        });
      });

      function loadFile(file) {
        if (!file || !/^image\//.test(file.type)) return;
        var r = new FileReader();
        r.onload = function (e) {
          photo.src = e.target.result;
          emptyEl.hidden = true; uploadEl.style.display = 'none';
          stage.hidden = false; controls.hidden = false;
          st.scale = 100; st.x = 0; st.y = 0; scale.value = 100; apply();
          hint.classList.add('is-visible');
          setTimeout(function () { hint.classList.remove('is-visible'); }, 2200);
        };
        r.readAsDataURL(file);
      }
      fileEl.addEventListener('change', function (e) { loadFile(e.target.files[0]); });
      ['dragover', 'dragenter'].forEach(function (ev) { uploadEl.addEventListener(ev, function (e) { e.preventDefault(); }); });
      uploadEl.addEventListener('drop', function (e) { e.preventDefault(); if (e.dataTransfer && e.dataTransfer.files[0]) loadFile(e.dataTransfer.files[0]); });

      resetBtn.addEventListener('click', function () {
        photo.src = ''; fileEl.value = ''; stage.hidden = true; controls.hidden = true;
        uploadEl.style.display = ''; emptyEl.hidden = false;
      });

      scale.addEventListener('input', function (e) { st.scale = parseInt(e.target.value, 10); sched(); });
      root.querySelectorAll('.mcp__scale-btn').forEach(function (b) {
        b.addEventListener('click', function () {
          st.scale = Math.min(240, Math.max(20, st.scale + parseInt(b.dataset.delta, 10)));
          scale.value = st.scale; sched();
        });
      });

      // drag
      var drag = false, lx = 0, ly = 0, pid = null;
      wrap.addEventListener('pointerdown', function (e) {
        if (stage.hidden || pid !== null) return;
        drag = true; pid = e.pointerId; lx = e.clientX; ly = e.clientY;
        wrap.classList.add('is-dragging');
        try { wrap.setPointerCapture(e.pointerId); } catch (x) {}
      });
      wrap.addEventListener('pointermove', function (e) {
        if (!drag || e.pointerId !== pid) return;
        e.preventDefault();
        st.x += e.clientX - lx; st.y += e.clientY - ly; lx = e.clientX; ly = e.clientY; sched();
      }, { passive: false });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
        wrap.addEventListener(ev, function (e) { if (e.pointerId === pid || pid === null) { drag = false; pid = null; wrap.classList.remove('is-dragging'); } });
      });

      // ---- Compose to canvas (engraved photo + crystal overlay) ----
      function compose(cb) {
        if (!photo.src) return;
        var SIZE = 1080;
        var c = document.createElement('canvas'); c.width = SIZE; c.height = SIZE;
        var ctx = c.getContext('2d');
        ctx.fillStyle = "#e8eaf2"; ctx.fillRect(0, 0, SIZE, SIZE);
        var wRect = wrap.getBoundingClientRect();
        var k = SIZE / wRect.width; // px(screen)->px(canvas)
        // contain fit at scale 1, then user scale + offset (mirrors CSS)
        var nW = photo.naturalWidth, nH = photo.naturalHeight;
        var fit = Math.min(wRect.width / nW, wRect.height / nH);
        var dW = nW * fit * (st.scale / 100) * k;
        var dH = nH * fit * (st.scale / 100) * k;
        var cx = SIZE / 2 + st.x * k, cy = SIZE / 2 + st.y * k;
        // Laser-etched look: luminance blended as light into the glass
        ctx.filter = 'grayscale(100%) contrast(1.28) brightness(1.32)';
        ctx.globalCompositeOperation = 'screen';
        try { ctx.drawImage(photo, cx - dW / 2, cy - dH / 2, dW, dH); } catch (e) {}
        ctx.filter = 'none';
        ctx.globalCompositeOperation = 'source-over';
        var ov = new Image(); ov.crossOrigin = 'anonymous';
        ov.onload = function () { ctx.drawImage(ov, 0, 0, SIZE, SIZE); c.toBlob(cb, 'image/png'); };
        ov.onerror = function () { c.toBlob(cb, 'image/png'); };
        ov.src = overlay.src;
      }

      if (dlBtn) dlBtn.addEventListener('click', function () {
        compose(function (blob) {
          if (!blob) return;
          var a = document.createElement('a');
          a.href = URL.createObjectURL(blob); a.download = 'mawj-crystal.png';
          document.body.appendChild(a); a.click(); a.remove();
          setTimeout(function () { URL.revokeObjectURL(a.href); }, 4000);
        });
      });
      if (shBtn) shBtn.addEventListener('click', function () {
        compose(function (blob) {
          if (!blob) return;
          var file = new File([blob], 'mawj-crystal.png', { type: 'image/png' });
          if (navigator.canShare && navigator.canShare({ files: [file] })) {
            navigator.share({ files: [file], title: 'MAWJ', text: window.mawjStrings.shareCaption }).catch(function () {});
          } else {
            var a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = 'mawj-crystal.png';
            document.body.appendChild(a); a.click(); a.remove();
            window.open('https://wa.me/?text=' + encodeURIComponent(window.mawjStrings.whatsappShareCaption + ' ' + location.origin), '_blank');
          }
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
